// import html
import template from './locations-selector-group-component.hogan.html';

// js
import { HtmlComponent } from './../html-component';
import { Gui } from './../../gui';
import { LocationsSelectorComponent } from './locations-selector/locations-selector-component';
import { TextComponent } from './../text/text-component';
import { SelectLocationCommandExecutor } from './../../commands/select-location-command-executor';

export class LocationsSelectorGroupComponent extends HtmlComponent {
    private locationSelectors: LocationsSelectorComponent[] = [];
    private text: TextComponent;

    constructor(private gui: Gui) {
        super(template, {});
        this.text = new TextComponent({ text: 'Draw circles on the map to filter on location' });
        this.text.addToParent(this);
        this.gui.commandManager.createdLocationCommand.attach((commandExecutor: SelectLocationCommandExecutor) => {
            this.addElement(commandExecutor);
        });
    }

    private addElement = (commandExecutor: SelectLocationCommandExecutor) => {
        let locSelComp = new LocationsSelectorComponent(commandExecutor, this);
        locSelComp.addToJqueryTag('.locations-selectors', this);
        this.locationSelectors.push(locSelComp);
        this.text.hide();
        return locSelComp;
    }

    public remove(el: LocationsSelectorComponent) {
        this.locationSelectors.splice(this.locationSelectors.indexOf(el), 1);
        el.jqueryElement.detach();

        if (this.locationSelectors.length === 0) {
            this.text.show();
        }
    }
}
